import { CmsSupportContactFormBlockLoadable } from './CmsSupportContactFormBlockLoadable';

import type { CmsApiSupportContactFormBlockData } from '#/modules/cms/api/types/blocks/CmsApiSupportContactFormBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';

export const CmsSupportContactFormBlockMapping: CmsBlockMapping<CmsApiSupportContactFormBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.FULL,
    Component: CmsSupportContactFormBlockLoadable,
  };
